export class AppAccordion extends HTMLElement {
    private items: { order: number; question: string; answer: string }[] = [];

    constructor() {
        super();
    }

    connectedCallback() {
        this.items = this.parseItems();
        this.render();
    }

    static get observedAttributes() {
        return ['items'];
    }

    parseItems(): { order: number; question: string; answer: string }[] {
        const raw = this.getAttribute('items');
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                return parsed.map((item: any) => ({
                    order: item.Order ?? item.order ?? 0,
                    question: item.Question ?? item.question ?? '',
                    answer: item.Answer ?? item.answer ?? '',
                }));
            } catch {
                // ignore
            }
        }
        // Fallback: read from child data attributes
        const children = Array.from(this.children);
        return children
            .filter(el => el.hasAttribute('data-question'))
            .map(el => ({
                order: parseInt(el.getAttribute('data-order') || '0', 10),
                question: el.getAttribute('data-question') || '',
                answer: el.getAttribute('data-answer') || '',
            }));
    }

    render() {
        // Clear existing
        this.innerHTML = '';

        const container = document.createElement('div');
        container.className = 'w-full flex flex-col gap-4';

        for (const item of this.items) {
            const id = `faq-${item.order}`;

            // Wrapper
            const wrapper = document.createElement('div');
            wrapper.className = 'w-full';

            // Button
            const btn = document.createElement('button');
            btn.className =
                'w-full bg-[#00298C] rounded-[6rem] px-6 md:px-8 py-2 flex items-center gap-4 md:gap-6 text-left hover:bg-[#001a6e] font-vastago';
            btn.setAttribute('data-target', id);

            // Number
            const numSpan = document.createElement('span');
            numSpan.className = 'text-[#FFD600] text-2xl md:text-3xl font-bold shrink-0';
            numSpan.textContent = String(item.order);

            // Question
            const qSpan = document.createElement('span');
            qSpan.className = 'text-[#C5EFFF] text-base md:text-xl font-medium flex-1 leading-tight';
            qSpan.textContent = item.question;

            // Arrow
            const arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            arrowSvg.setAttribute('class', 'faq-arrow w-6 h-6 text-[#FFD600] shrink-0 transition-transform duration-300');
            arrowSvg.setAttribute('fill', 'currentColor');
            arrowSvg.setAttribute('viewBox', '0 0 20 20');
            arrowSvg.innerHTML =
                '<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />';

            btn.append(numSpan, qSpan, arrowSvg);

            // Answer
            const answerDiv = document.createElement('div');
            answerDiv.id = id;
            answerDiv.className = 'faq-answer hidden bg-[#00298C] rounded-b-2xl px-6 md:px-8 py-6';
            const p = document.createElement('p');
            p.className = 'text-white text-base md:text-lg leading-relaxed font-segma';
            // Convertir saltos de línea en <br> para permitir formato multilínea
            p.innerHTML = item.answer.replace(/\n/g, '<br>');
            answerDiv.appendChild(p);

            wrapper.append(btn, answerDiv);
            container.appendChild(wrapper);
        }

        this.appendChild(container);
        this.bindEvents();
    }

    bindEvents() {
        const buttons = this.querySelectorAll<HTMLButtonElement>('button[data-target]');
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                const targetId = btn.getAttribute('data-target')!;
                const answer = document.getElementById(targetId);
                const arrow = btn.querySelector('.faq-arrow') as SVGElement | null;
                const allAnswers = this.querySelectorAll<HTMLElement>('.faq-answer');
                const allArrows = this.querySelectorAll<SVGElement>('.faq-arrow');
                const allButtons = this.querySelectorAll<HTMLButtonElement>('button[data-target]');

                const isOpen = answer && !answer.classList.contains('hidden');

                allAnswers.forEach(el => el.classList.add('hidden'));
                allArrows.forEach(el => (el.style.transform = 'rotate(0deg)'));
                allButtons.forEach(b => {
                    b.classList.remove('rounded-tl-[2rem]', 'rounded-tr-[2rem]');
                    b.classList.add('rounded-[6rem]');
                });

                if (answer && !isOpen) {
                    answer.classList.remove('hidden');
                    if (arrow) arrow.style.transform = 'rotate(180deg)';
                    btn.classList.remove('rounded-[6rem]');
                    btn.classList.add('rounded-tl-[2rem]', 'rounded-tr-[2rem]');
                }
            });
        });
    }
}

if (typeof window !== 'undefined') {
    customElements.define('app-accordion', AppAccordion);
}